
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/off-road-tours",
      function () {
        return require("private-next-pages/off-road-tours.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/off-road-tours"])
      });
    }
  